import React from "react";

import { Box, Container, Typography } from "@mui/material";

import { FaUsers, FaStar, FaAward, FaTruck } from "react-icons/fa";

import statsBg from "../../assets/images/start_bg_s_f.png";
import statsBgMo from "../../assets/images/start_bg_s_f_mobile.png";

const stats = [
  {
    number: "1000+",
    title: "Happy Customers",
    icon: <FaUsers />,
  },

  {
    number: "98%",
    title: "Satisfaction Rate",
    icon: <FaStar />,
  },

  {
    number: "10+",
    title: "Years Experience",
    icon: <FaAward />,
  },

  {
    number: "24/7",
    title: "Pickup & Delivery",
    icon: <FaTruck />,
  },
];

function StatsSection() {
  return (
    <Box
      sx={{
        backgroundImage: { xs: `url(${statsBgMo})`, md: `url(${statsBg})` },
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",

        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        {/* BADGE */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <Box
            sx={{
              px: {
                xs: 2,
                md: 2.5,
              },

              py: 1,

              borderRadius: "50px",

              background: "rgba(255,255,255,.65)",

              backdropFilter: "blur(12px)",

              border: "1px solid rgba(0,87,255,.08)",

              color: "#0057ff",

              fontWeight: 700,

              textTransform: "uppercase",

              letterSpacing: "1px",

              fontSize: {
                xs: "11px",
                md: "12px",
              },
            }}
          >
            Why Families Choose Comet Cleaners
          </Box>
        </Box>

        {/* HEADING */}

        <Typography
          sx={{
            fontSize: {
              xs: "32px",
              sm: "38px",
              md: "48px",
              lg: "54px",
            },

            fontWeight: 800,

            color: "#0f172a",

            lineHeight: 1.08,

            textAlign: "center",

            maxWidth: "850px",

            mx: "auto",
          }}
        >
          Trusted By{" "}
          <Box
            component="span"
            sx={{
              color: "#0057ff",
            }}
          >
            1,000+
          </Box>{" "}
          Families Across Ajax
        </Typography>

        {/* SUBTITLE */}

        <Typography
          sx={{
            mt: 2,

            mb: {
              xs: 4,
              md: 5,
            },

            color: "#64748b",

            fontSize: {
              xs: "15px",
              md: "17px",
            },

            lineHeight: 1.8,

            maxWidth: "700px",

            mx: "auto",

            textAlign: "center",
          }}
        >
          Complete cleaning, repair and specialty care services trusted by
          families across Ajax for quality workmanship, convenience and reliable
          results.
        </Typography>

        {/* STATS */}

        <Box
          sx={{
            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            gap: {
              xs: 1.5,
              md: 2,
            },

            maxWidth: "1200px",

            mx: "auto",
          }}
        >
          {stats.map((item, index) => (
            <Box
              key={index}
              sx={{
                position: "relative",
                width: {
                  xs: "calc(50% - 8px)",
                  md: "270px",
                },
                backgroundImage: {
                  xs: `url(${statsBgMo})`,
                  md: `url(${statsBg})`,
                },
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                background: "rgba(255,255,255,.75)",

                backdropFilter: "blur(16px)",

                border: "1px solid rgba(255,255,255,.9)",

                borderRadius: "22px",

                px: {
                  xs: 1.5,
                  md: 2.5,
                },

                py: {
                  xs: 1.5,
                  md: 2,
                },

                display: "flex",

                alignItems: "center",

                gap: 1.5,

                transition: ".35s",

                "&:hover": {
                  transform: "translateY(-5px)",

                  boxShadow: "0 18px 40px rgba(0,87,255,.12)",
                },
              }}
            >
              {/* ICON */}

              <Box
                sx={{
                  width: {
                    xs: 46,
                    md: 56,
                  },

                  height: {
                    xs: 46,
                    md: 56,
                  },

                  borderRadius: "50%",

                  background: "linear-gradient(135deg,#0057ff,#2f8cff)",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  color: "#fff",

                  fontSize: {
                    xs: 18,
                    md: 22,
                  },

                  flexShrink: 0,

                  boxShadow: "0 10px 25px rgba(0,87,255,.25)",
                }}
              >
                {item.icon}
              </Box>

              {/* CONTENT */}

              <Box>
                <Typography
                  sx={{
                    fontSize: {
                      xs: "20px",
                      md: "30px",
                    },

                    fontWeight: 800,

                    color: "#0057ff",

                    lineHeight: 1,
                  }}
                >
                  {item.number}
                </Typography>

                <Typography
                  sx={{
                    fontSize: {
                      xs: "12px",
                      md: "14px",
                    },

                    fontWeight: 600,

                    color: "#0f172a",

                    mt: 0.5,

                    lineHeight: 1.3,
                  }}
                >
                  {item.title}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default StatsSection;
